import { sessionUrlFilterFromJson } from './sessionUrlFilterFromJson.mjs'

export class FilterGroup {
  constructor({ filters = [] }) {
    this.filters = filters.map((filterJson) =>
      sessionUrlFilterFromJson(filterJson),
    )
  }
  get exclusiveFilters() {
    return this.filters.filter((f) => !f.inclusive)
  }

  get inclusiveFilters() {
    return this.filters.filter((f) => f.inclusive)
  }

  removeFilterByHashCode(hashCode) {
    const idx = this.filters.findIndex((f) => f.hashCode() === hashCode)
    if (idx !== -1) this.filters.splice(idx, 1)
  }

  getFilterByHashCode(hashCode) {
    return this.filters.find((f) => f.hashCode() === hashCode) || null
  }

  removeFiltersByHashCode(...hashCodes) {
    for (let i = this.filters.length - 1; i >= 0; i--) {
      if (hashCodes.includes(this.filters[i].hashCode())) {
        this.filters.splice(i, 1)
      }
    }
    q
  }

  evaluate(url) {
    for (const filter of this.inclusiveFilters) {
      if (filter.matches(url)) {
        return true // inclusion trumps all
      }
    }
    for (const filter of this.exclusiveFilters) {
      if (filter.matches(url)) {
        return false // exclusion wins if no inclusions matched
      }
    }
    return true // default allow
  }

  explain(url) {
    // Explain why a value doesn't match the filter group.  Give the first
    // exclusive filter explanation that matches.
    for (const filter of this.exclusiveFilters) {
      if (filter.matches(url)) {
        return filter.explain(url)
      }
    }
    return null
  }

  get inclusiveFilterTypes() {
    const result = new Set()
    for (const filter of this.inclusiveFilters) {
      result.add(filter.type)
    }
    return [...result]
  }

  get exclusiveFilterTypes() {
    const result = new Set()
    for (const filter of this.exclusiveFilters) {
      result.add(filter.type)
    }
    return [...result]
  }

  toJson() {
    // Weed out any duplicates
    const hashesSeen = new Set()
    const result = { filters: [] }
    for (const filter of this.filters) {
      const hash = filter.hashCode()
      if (!hashesSeen.has(hash)) {
        hashesSeen.add(hash)
        result.filters.push(filter.toJson())
      }
    }
    return result
  }
  //
  // push(...items) {
  //   for (const item of items) {
  //     if (!(item instanceof AbstractPersistentFilter))
  //       throw new Error(
  //         'FilterGroups only accept AbstractPersistentFilter instances',
  //       )
  //   }
  //   this.removeFiltersByHashCode(...items.map((i) => i.hashCode()))
  //   return super.push(...items)
  // }
  //
  // unshift(...items) {
  //   this.removeFiltersByHashCode(...items.map((i) => i.hashCode()))
  //   return super.unshift(...items)
  // }
  //
  // splice(start, deleteCount, ...items) {
  //   const originalElements = [...this]
  //   super.splice(start, deleteCount, ...items)
  //   const hashCodesSeen = new Set(items.map((i) => i.hashCode()))
  //   const bounds = [
  //     { start: this.length - 1, end: start + items.length },
  //     { start: start - 1, end: 0 },
  //   ]
  //   for (const { start, end } of bounds) {
  //     for (let i = start; i >= end; i--) {
  //       if (!hashCodesSeen.has(this[i].hashCode())) {
  //         hashCodesSeen.add(this[i].hashCode())
  //       } else {
  //         this.splice(i, 1)
  //       }
  //     }
  //   }
  //   const remainingHashes = new Set(this.map((f) => f.hashCode()))
  //   const result = []
  //   for (const element of originalElements) {
  //     if (!remainingHashes.has(element.hashCode())) {
  //       result.push(element)
  //     }
  //   }
  //   return result
  // }

  clone() {
    return new FilterGroup(this.toJson())
  }

  addFilter(filter) {
    this.removeFilterByHashCode(filter.hashCode())
    this.filters.push(filter)
  }

  equals(other) {
    if (!(other instanceof FilterGroup)) return false
    if (this.filters.length !== other.filters.length) return false
    const thisHashes = new Set(this.filters.map((f) => f.hashCode()))
    const otherHashes = new Set(other.filters.map((f) => f.hashCode()))
    if (thisHashes.size !== otherHashes.size) return false
    for (const hash of thisHashes) {
      if (!otherHashes.has(hash)) return false
    }
    return true
  }
}
